import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router';
import HomePage from './pages/HomePage';
import AdminPage from './pages/admin/AdminLogin';
import AdminPortal from './pages/admin/AdminPortalPage';
import ArchivePage from './pages/ArchivePage';
import { ModalProvider } from '../context/ModalContext';
import DemoPage from './pages/DemoPage';
import { GameProvider } from '../context/GameContext';
import ErrorPage from './pages/ErrorPage';

function App() {
  return (
    <ModalProvider>
      <BrowserRouter>
        <GameProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/portal" element={<AdminPortal />} />
            <Route path="/:dateString" element={<HomePage />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </GameProvider>
      </BrowserRouter>
    </ModalProvider>
  );
}

export default App;
